import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

// Connects to data-controller="account-toggle"
export default class extends Controller {
  static targets = ['toggleButton', 'confirmModal', 'confirmModalTitle', 'confirmModalMessage', 'confirmModalBtn']
  static values = { 
    accountId: String,
    accountName: String,
    isActivated: Boolean
  }
  
  connect() {
    this.confirmModal = new bootstrap.Modal(this.confirmModalTarget)
  }

  showConfirmModal(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const isActivated = this.isActivatedValue
    const action = isActivated ? 'disable' : 'enable'
    
    // Update modal content
    this.confirmModalTitleTarget.textContent = `${action.charAt(0).toUpperCase() + action.slice(1)} Organization`
    this.confirmModalMessageTarget.textContent = `Are you sure you want to ${action} this organization?`
    this.confirmModalBtnTarget.textContent = action.charAt(0).toUpperCase() + action.slice(1)
    
    // Show modal
    this.confirmModal.show()
  }

  confirmToggle() {
    // Hide confirmation modal
    this.confirmModal.hide()
    
    // Show TOTP verification modal
    this.showTotpModal()
  }

  showTotpModal() {
    // Use the reusable TOTP verification modal
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: `/accounts/${this.accountIdValue}/toggle_activation`,
        actionMethod: 'PATCH',
        formData: {}
      }
    })
    document.dispatchEvent(event)
  }

  disconnect() {
    if (this.confirmModal) {
      this.confirmModal.dispose()
    }
  }
} 